import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { MessageSquare, BookOpen, User, RefreshCw } from "lucide-react";

type Tab = "chat" | "loop" | "methods" | "profile";

interface BottomNavProps {
  activeTab: Tab;
  onTabChange: (tab: Tab) => void;
}

export const BottomNav = ({ activeTab, onTabChange }: BottomNavProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  
  const tabs = [
    { id: "chat" as Tab, label: t('nav.chat'), icon: MessageSquare, path: "/chat" },
    { id: "methods" as Tab, label: "TOOLBOX", icon: BookOpen, path: "/chat" },
    { id: "profile" as Tab, label: t('nav.profile'), icon: User, path: "/profile" },
  ];

  const handleTabClick = (tab: Tab) => {
    if (tab === "methods") {
      // Navigate to chat route and set methods tab
      navigate("/chat", { state: { activeTab: "methods" } });
      onTabChange(tab);
    } else {
      const tabConfig = tabs.find(t => t.id === tab);
      if (tabConfig) {
        navigate(tabConfig.path);
      }
    }
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-card border-t border-border z-50 lg:hidden">
      <div className="flex items-center justify-around h-16">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = tab.id === "methods" 
            ? activeTab === "methods" 
            : location.pathname === tab.path;
          
          return (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab.id)}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
                isActive
                  ? "text-primary"
                  : "text-muted-foreground hover:text-foreground"
              }`}
            >
              <Icon className={`h-5 w-5 mb-1 transition-transform ${isActive ? "scale-110" : ""}`} />
              <span className="text-xs font-medium">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export type { Tab };
